export default __webpack_public_path__ + "static/media/background.111327d8.png";